import HeaderContainer from '../components/connectedForm/HeaderContainer';
import Heading2 from '../components/connectedForm/Heading2';
import HeaderEntityValue from '../components/connectedForm/HeaderEntityValue';
import React, { CSSProperties, FunctionComponent, ReactElement, ReactNode } from 'react';

/**
 * A (relatively) basic header display component, typically used for modals.
 * @param children        - Typically expecting the title to be the components immediate child.
 * @param secondaryTitle  - An optional secondary title, displayed below the main title in smaller text.
 * @param tertiaryTitle   - An optional tertiary title, displayed to the right of the main title.
 * @param styles          - Optional styles property, for more precise configuration of appearance.
 */
export const BasicHeader: FunctionComponent<{
  secondaryTitle?: ReactNode;
  tertiaryTitle?: string;
  styles?: { container?: CSSProperties; primary?: CSSProperties; secondary?: CSSProperties };
  children: ReactNode;
}> = ({ children, secondaryTitle, tertiaryTitle, styles = {} }) => {
  return (
    <HeaderContainer style={{ paddingBottom: '7px', paddingTop: '7px', ...styles.container }}>
      <Heading2 style={{ paddingBottom: secondaryTitle ? '0px' : undefined, flexDirection: 'column' }}>
        <HeaderEntityValue style={styles.primary}>
          {children}
          <span style={{ marginLeft: '9px', color: 'gray', fontSize: '14px', fontWeight: 400 }}>{tertiaryTitle}</span>
        </HeaderEntityValue>
        {secondaryTitle ? (
          <div style={{ marginTop: '2px', color: 'gray', fontSize: '14px', fontWeight: 400, ...styles.secondary }}>
            {secondaryTitle}
          </div>
        ) : null}
      </Heading2>
    </HeaderContainer>
  );
};
